import { render, staticRenderFns } from "./Submissions.vue?vue&type=template&id=009c37e6&"
import script from "../js/submissions.js?vue&type=script&lang=js&"
export * from "../js/submissions.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports